'use client';

import type { ShareBrandPayload } from 'src/types/hub/hub-share';

import Stack from '@mui/material/Stack';

import { HubShell } from 'src/components/cmui/hub/hub-shell';
import { HubConversionBand } from 'src/components/cmui/hub/hub-conversion-band';
import { PublicShareShell } from 'src/components/cmui/public-share/public-share-shell';

import { BrandHubOverview } from './components/brand-hub-overview';
import { BRAND_HUB_SHARE_PITCH } from './constants/brand-hub-share';
import { useBrandHubShareViewModel } from './hooks/use-brand-hub-share-view-model';
import { BrandHubDetailHead, BrandHubHeadActions } from './components/brand-hub-detail-head';

/**
 * 브랜드 공유 페이지(비회원 공개) — **로그인한 상세 화면 그대로**(대상 카드 · 탭 · 개요)를 공유한 사람의
 * 조건으로 그리고, 공유 페이지 껍데기(`PublicShareShell` `gate="end"`)가 밝은 막을 씌운다 — 위쪽은 읽히고 아래로
 * 갈수록 흐려지며, 가입 안내는 문서 끝에 선다(첫 화면부터 내용이 보인다).
 *
 * 🔑 부품은 상세와 같다(`BrandHubDetailHead` · `BrandHubOverview`) — 숫자는 서버가 같은 질문으로 받아 왔다.
 * ⚠️ 조건 줄(기간·칩·「목록으로」)은 세우지 않는다 — 고칠 수 없는 칸을 보이면 고칠 수 있는 줄로 읽힌다(기간은 서버가 정한 한 벌).
 */
export function BrandHubShareView({ data }: { data: ShareBrandPayload }) {
  const vm = useBrandHubShareViewModel(data);

  return (
    <PublicShareShell
      gate="end"
      source="brand-hub"
      pitch={BRAND_HUB_SHARE_PITCH}
      background={
        <HubShell title="브랜드 허브">
          <Stack spacing={2}>
            <BrandHubDetailHead {...vm.head} actions={<BrandHubHeadActions {...vm.actions} />} />
            <BrandHubOverview {...vm.overview} researchBand={<HubConversionBand {...vm.research} action="Research" />} />
          </Stack>
        </HubShell>
      }
    />
  );
}
